import Headroom from "headroom.js"

const mainHeader = document.querySelector(".m-header")

const headRoomHeaderOptions: Headroom.HeadroomOptions = {
  offset: mainHeader?.clientHeight ?? 0,
}

export const headRoomHeader = mainHeader ? new Headroom(mainHeader, headRoomHeaderOptions) : null

if (headRoomHeader) headRoomHeader.init()

const focusNewsletterButton = document.querySelector(".m-header__focus-newsletter")

focusNewsletterButton?.addEventListener('click', (e) => {
  e.preventDefault()

  const heroNewsletterInput = document.querySelector<HTMLInputElement>(".s-hero .f-newsletter input")

  heroNewsletterInput?.focus({preventScroll: false})
})
